import { makeAutoObservable } from 'mobx'
import * as API from '../../../service/api/InfoStat/DeviceStatApi'
import table from '../../commons/table'
import { downloadFileStream } from '../../../util'

class DeviceStatStore {
  constructor() {
    makeAutoObservable(this)
  }

  get table() {
    return new table(API.GET_DEVICE_LIST)
  }

  init = (param, pageNo, pageSize) => {
    this.table.init(param)
    this.table.getList(pageNo, pageSize)
  }

  exportLog = async (data) => {
    let res = await API.EXPORT_DEVICE_LIST(data)
    downloadFileStream(res, '设备列表')
  }
}

export default new DeviceStatStore()
